// Camera / microphone helpers: acquire, enumerate, switch.

export type DeviceLists = { cams: MediaDeviceInfo[]; mics: MediaDeviceInfo[] }

export async function getMedia(constraints: MediaStreamConstraints = {}): Promise<MediaStream> {
  const audio = typeof constraints.audio === "object" ? constraints.audio : {}
  const video = typeof constraints.video === "object" ? constraints.video : {}
  return navigator.mediaDevices.getUserMedia({
    audio: { echoCancellation: true, noiseSuppression: true, ...audio },
    video: { width: { ideal: 1280 }, height: { ideal: 720 }, ...video },
  })
}

export async function listDevices(): Promise<DeviceLists> {
  const all = await navigator.mediaDevices.enumerateDevices()
  return {
    cams: all.filter((d) => d.kind === "videoinput"),
    mics: all.filter((d) => d.kind === "audioinput"),
  }
}

export function currentDeviceId(stream: MediaStream | null, kind: "audio" | "video"): string {
  const track = kind === "video" ? stream?.getVideoTracks()[0] : stream?.getAudioTracks()[0]
  return track?.getSettings().deviceId ?? ""
}

export function stopStream(stream: MediaStream | null): void {
  stream?.getTracks().forEach((t) => t.stop())
}
